  console.log('simple-bundles.js loaded');

  var selections = [];

  var updateSelections = function() {
    selections = [];
    $('.ProductForm__Variants .selector__select').each(function() {
      if ($(this).val()) {
        selections.push($(this).val());
      }
    });
    //console.log('selections', selections);

    if (selections.length == $('.ProductForm__Variants .selector__select').length) {
      //console.log('enabled', selections.length, $('.ProductForm__Variants .selector__select').length);
      $('.ProductForm__AddToCart').prop('disabled', false);
    } else {
      //console.log('disabled', selections.length, $('.ProductForm__Variants .selector__select').length);
      $('.ProductForm__AddToCart').prop('disabled', true);
    }
  }

  var initSelectors = function() {

    $('.selector-btn, .btn-select').off('click');
    $('.selector-btn').on('click', function(e) {
      e.preventDefault();
      var parent = $(this).parents('.selector-box').first();
      var selector = $(this).data('target');
      var value = $(this).data('value');
      var img = '<img src="' + $(this).data('img') + '" alt="' + value + '" />';
      $('.selector-btn[data-target="' + selector + '"]').removeClass('selected');
      $('#' + selector).val(value);
      //$('.selected-option--' + selector).html(' - ' + value);
      parent.find('.btn-select').html(img);
      $(this).addClass('selected');
      
      parent.find('.selections__label strong').html(value);
      
      parent.find('.selections').fadeOut();
      parent.removeClass('selector-box--open').addClass('selector-box--selected');

      updateSelections();
    });

    $('.btn-select').on('click', function(e) {
      e.preventDefault();
      //console.log('test');
      var container = $(this).parents('.selector-box').first();
      if (container.hasClass('selector-box--open')) {
        $('.selections').fadeOut();
        container.removeClass('selector-box--open');
      } else {
        $('.selections').hide();
        $('.selector-box--open').removeClass('selector-box--open');
        container.addClass('selector-box--open');
        var selector = container.find('.selections').show();
      }
    });

    $('.ProductForm__Variants .selector__select').val('');

    if (selections.length) {
      $.each(selections, function(index, value) {
        //$('.ProductForm__Variants .selector__select').eq(index).val(value);

        $('.ProductForm__Variants .selector-btn[data-value="' + value + '"]').eq(index).click();
      });
    }

  }
  jQuery(document).ready(function($) {
    

    var bundle_options = JSON.parse(document.getElementById('bundle-option-data').textContent);


    $('.selector-btn').each(function() {

      var btn = $(this);
      //console.log('bundle_options', bundle_options);
      var target_title = btn.data("value");
      if (target_title == "D569 Hallo-Queen") {
        target_title = "D569 Hallow-Queen";
      }
      target_title = target_title.replace("D00", "D").replace("D0", "D");
      var option = bundle_options.filter(function(el){return el.title.toLowerCase().includes(target_title.toLowerCase())});
      console.log('target_title', target_title, option);
      if (option.length) {
        option = option[0];
        //console.log('option', option);
        //console.log('img', option.img);
        btn.attr('data-img', option.img);
        btn.find('span').css('background-image', 'url(' + option.thumb + ')');
        //console.log('selector', target_title, option);
      } else {
        $(this).hide();
      }
    });

    initSelectors();
    updateSelections();

    
  });

  document.addEventListener('variant:changed', function(event) {
      //console.log('variantchanged');
      var variant = event.detail.variant;
      $('#simple-bundles-options').html($('#simple-bundles-options-' + variant.id).html());
      initSelectors();
  });    

  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  }
  function renderBundleVariantOptions(variantId) {
    if (variantId) {
      var simpleBundlesOptions = document.querySelector(
        "#simple-bundles-options-html #simple-bundles-options-" + variantId
      );
    } else {
      var simpleBundlesOptions = document.querySelector(
        "#simple-bundles-options-html #simple-bundles-options"
      );
    }
    var simpleBundlesOptionsContainer = document.getElementById(
      "simple-bundles-options-container"
    );
    if (simpleBundlesOptions) {
      if (simpleBundlesOptionsContainer) {
        simpleBundlesOptionsContainer.innerHTML = "";
        simpleBundlesOptionsContainer.appendChild(simpleBundlesOptions);
      } else {
        var cartFormHiddenInputs = document.querySelector(
          'form[action$="/cart/add"]:not([id^="product-form-installment"]) > input[type=hidden]'
        );
        var simpleBundlesOptionsContainerDOM = document.createElement("div");
        simpleBundlesOptionsContainerDOM.id = "simple-bundles-options-container";
        insertAfter(simpleBundlesOptionsContainerDOM, cartFormHiddenInputs);
        document
          .getElementById("simple-bundles-options-container")
          .appendChild(simpleBundlesOptions);
      }
    }
  }
  (function () {
    renderBundleVariantOptions(null);
  })();